// NOTE: we import directly from core-decorators (instead '@base/decorators'),
// as this file is one of the first being loaded, we don't want to pull in too many dependencies yet
import nonenumerable from 'core-decorators/lib/nonenumerable'

const PROBER = Symbol('prober')

type ProberType = {
  captureAction: Function
  captureError: Function
  captureWarning: Function
}

export function mergeInteractionData(a: any, b: any) {
  // in case we need some specific logic in the future for merging interaction meta in the future
  return {...a, ...b}
}

export class InteractionTemplate {
  constructor(prober: ProberType, interaction: any) {
    this[PROBER] = prober
    // Assign data to this, so it's accessible with JS property getters
    Object.assign(this, interaction)
    Object.freeze(this)
  }

  @nonenumerable
  captureAction(category, action, meta): InteractionTemplate {
    return this[PROBER].captureAction(
      category,
      action,
      mergeInteractionData(this, meta)
    )
  }

  @nonenumerable
  captureError(category, error, meta): void {
    this[PROBER].captureError(category, error, mergeInteractionData(this, meta))
  }

  @nonenumerable
  captureWarning(category, error, meta): void {
    this[PROBER].captureWarning(
      category,
      error,
      mergeInteractionData(this, meta)
    )
  }

  @nonenumerable
  toPlain(): any {
    return {...this}
  }
}

/** @see app/docs/CapturingMetrics.md, use preconfigured function from @base/app-services/prober */
export function withInteraction(
  prober: ProberType,
  interaction?: any | null
): InteractionTemplate {
  return new InteractionTemplate(prober, interaction || {})
}
